export enum CartStep {
    CUSTOMER_DETAILS,
    DELIVERY_DETAILS
}
